import { render, staticRenderFns } from "./MobileManageView.vue?vue&type=template&id=1828bd16&scoped=true"
import script from "./MobileManageView.vue?vue&type=script&lang=js"
export * from "./MobileManageView.vue?vue&type=script&lang=js"
import style0 from "./MobileManageView.vue?vue&type=style&index=0&id=1828bd16&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1828bd16",
  null
  
)

export default component.exports